import React from 'react'
import { t } from 'ttag'
import { ReactComponent as GoalIcon } from '../../../assets/v2/icons/icon-filled-goal.svg'
import { ReactComponent as PrizeIcon } from '../../../assets/v2/icons/icon-filled-prize.svg'
import { ReactComponent as DescriptionIcon } from '../../../assets/v2/icons/icon-description.svg'
import { ReactComponent as PeriodIcon } from '../../../assets/v2/icons/icon-filled-time.svg'
import { ProgressType } from '../../../services/api.types'
import Loader from '../../Loader/Loader'
import './ActivityCardSection.scss'

export interface IActivitySection {
  type: 'goal' | 'time' | 'prize' | 'empty' | 'title' | 'description'
  content: string | number | JSX.Element
  description?: string
  status?: string
  activity?: ProgressType
  isLoading?: boolean
}

export class ActivityCardSection extends React.PureComponent<IActivitySection> {
  renderHeader() {
    switch (this.props.type) {
      case 'title':
        return <>{t`Title`}</>
      case 'goal':
        return <>{t`Goal`}</>
      case 'time':
        return (
          <>
            {t`Period`}
            {this.props.status && <span className={'activity-card-section__goal-status'}>{this.props.status}</span>}
          </>
        )
      case 'prize':
        return <>{t`Prize`}</>
      case 'description':
        return <>{t`Description`}</>
      case 'empty':
        // return <>{t`Goal`}</>
        return ''
    }
  }

  renderContentIcon() {
    const { activity, type } = this.props

    const iconClassName = `activity-card-section__icon activity-card-section__icon--${type}`
    const activityIcon = <GoalIcon className={iconClassName} />

    switch (type) {
      case 'title':
        return activityIcon
      case 'goal':
        return activityIcon
      case 'time':
        return <PeriodIcon className={iconClassName} />
      case 'prize':
        return <PrizeIcon className={iconClassName} />
      case 'description':
        return <DescriptionIcon className={iconClassName} />
      case 'empty':
        return <GoalIcon className={iconClassName} />
    }
  }

  renderContent() {
    const { content } = this.props

    return <div className="activity-card-section__text">{content}</div>
  }

  BEM = () => {
    const classArr = ['activity-card-section']
    classArr.push(`activity-card-section--${this.props.type}`)

    return classArr.join(' ')
  }

  render() {
    return (
      <div className={this.BEM()}>
        {this.props.isLoading ? (
          <Loader inverse={true} />
        ) : (
          <>
            <header className="activity-card-section__header">{this.renderHeader()}</header>
            <section className="activity-card-section__content">
              {this.renderContentIcon()}
              {this.renderContent()}
            </section>
          </>
        )}
      </div>
    )
  }
}
